import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { User } from '../../../models/User';
import { Establishment } from '../../../models/Establishment';
import { displayImg } from '../../utils/utils.functions';
import { MissionDetailsComponent } from '../../../pages/etablissement/missions/encour-component/mission-details/mission-details.component';
import { MatDialog } from '@angular/material/dialog';
import { EstablishmentService } from './../../../services/establishment.service';
import { MissionService } from './../../../services/mission.service';
import { NotificationRealtimeService } from '../../../services/notification-realtime.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-etablissement-header',
  templateUrl: './etablissement-header.component.html',
  styleUrl: './etablissement-header.component.scss',
})
export class EtablissementHeaderComponent implements OnInit, OnDestroy {
  user: User | null;
  notifNotReaded: number = 0;
  establishment: Establishment | null;
  notification: any[];
  private realtimeSub?: Subscription;
  constructor(
    private router: Router,
    private authService: AuthService,
    private missionService: MissionService,
    private dialog: MatDialog,
    private cookie: CookieService,
    private realtime: NotificationRealtimeService
  ) {
    this.user = this.authService.user;
  }
  disconnect() {
    localStorage.clear();
    this.authService.disconnect();
  }

  ngOnInit(): void {
    this.establishment = this.authService.establishment;
    this.notifications();
    // Live updates: prepend new notifications and bump the unread badge without a refresh.
    this.realtime.connect();
    this.realtimeSub = this.realtime.notifications$.subscribe((notif) => {
      this.notification = [notif, ...(this.notification || [])];
      this.notifNotReaded = (this.notifNotReaded || 0) + 1;
    });
  }

  ngOnDestroy(): void {
    this.realtimeSub?.unsubscribe();
    this.realtime.disconnect();
  }
  notifications() {
    this.authService.notif().subscribe({
      next: (res: any) => {
        this.notification = res;
        this.notifNotReaded = res?.filter((el: any) => !el.read).length;
      },
      error: (err) => console.log(err),
    });
  }

  missionDetailDialog = (row: any) => {
    const dialog = this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: row,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        // this.fetshMission()
      }
    });
  };
  notifClicked(mission: any) {
    // this.missionService.getMissionById(mission.mission_id).subscribe({
    //   next: (res) => {

    this.authService
      .readNotif(mission.id, { ...mission, read: true })
      .subscribe({
        next: (res) => {
          this.notifications();
          this.missionDetailDialog({ id: mission.mission_id });
        },
        error: (err) => {
          console.log(err);
        },
      });
    //   },
    //   error: (err) => {
    //     console.log(err);
    //   },
    // });

    // this.notification = this.notification.map((el: any) => {
    //   if (el.mission_id == mission.id) {
    //     el.read = true;
    //   }
    //   return el;
    // });
    // localStorage.setItem('notif', JSON.stringify(this.notification));
  }

  protected readonly displayImg = displayImg;
}
